jQuery(document).ready(function ($) {
    jQuery("a[href='#']").attr("href", "javascript:void(0)");

    jQuery(".validation_message").attr("role", "alert");
    jQuery(document).on('gform_page_loaded', function (event, form_id, current_page) {
        jQuery(".validation_message").attr("role", "alert");
    });

    jQuery(document).on("click", ".site_header button#primary-mobile-menu", function () {

        $('body').toggleClass("open_nav");
        $(this).toggleClass("active");
        $(this).parent().next().slideToggle(500);

    });

    jQuery(".faq").each(function (index) {
        jQuery(this).find(".faq_wrapper_list_item .faq_wrapper_list_item_inner_question").on("click", function (e) {
            e.preventDefault();
            $(this).parent().parent().siblings().find(".faq_wrapper_list_item_inner_answer").slideUp(400);
            $(this).parent().parent().siblings().removeClass("active");
            $(this).parent().parent().toggleClass("active");
            $(this).parent().find('.faq_wrapper_list_item_inner_answer').slideToggle(400);
        });
    });

    jQuery(document).on("click", ".open_nav .site_header__navigation .sub-menu-toggle", function () {
        $(this).toggleClass("active").next().slideToggle(500);
    });

    jQuery(".left_right_image_with_heading_content_inner_wrapper").each(function (index) {
        var slider = $(this).find('.image_section_slider');
        slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            autoplay: false,
            infinite: false,
        });
    });

    jQuery(".left_right_image_with_heading_content_inner_wrapper .image_section_slider ul.slick-dots").each(function (index) {
        if (jQuery(this).find('li').length == 1) {
            jQuery(this).remove();
        }
    });

    $('.testimonial_list').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: $('.testimonial_slider_arrow .pevious_arrow'),
        nextArrow: $('.testimonial_slider_arrow .next_arrow'),
        dots: true,
        autoplay: false,
        appendDots: $(".testimonial_slider_dots_section .global_slick_slider_dots_for_desktop"),
        infinite: false,
        responsive: [{
            breakpoint: 992,
            settings: {
                arrows: false,
                autoplay: true,
            }
        }, ]
    });

    $('.image_video_slider_with_content_sec__inner__slider__list').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        autoplay: false,
        focusOnSelect: true,
        variableWidth: true,
        infinite: true,
    });

    $('.image_video_popup_slider_list').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        autoplay: false,
        focusOnSelect: true,
        variableWidth: false,
        infinite: false,
        prevArrow: jQuery("#image_video_sliderlist_popup").find(".prev_arrow"),
        nextArrow: jQuery("#image_video_sliderlist_popup").find(".next_arrow"),
        responsive: [{
            breakpoint: 768,
            settings: {
                arrows: false
            }
        }, ]
    });

    if (jQuery(".image_video_slider_with_content_sec__inner__slider__list .slider_item").length > 0) {
        jQuery(".image_video_slider_with_content_sec__inner__slider__list .slider_item").on("click", function () {
            var litynew = new lity("#image_video_sliderlist_popup");
            var clickIndex = jQuery(this).attr("data-slick-index");
            setTimeout(() => {
                jQuery(".lity").addClass("ivs_full_width_popup");
                jQuery("#image_video_sliderlist_popup .image_video_popup_slider_list").slick("setPosition", 0);
                jQuery("#image_video_sliderlist_popup .image_video_popup_slider_list").slick('refresh');
                setTimeout(() => {
                    jQuery("#image_video_sliderlist_popup .image_video_popup_slider_list").slick("slickGoTo", clickIndex);
                }, 500);
            });
        })
    }

    jQuery(".close_popup").on("click", function () {
        jQuery("[data-lity-close]").click();
    })

    if (jQuery(window).width() < 992) {
        $('.footer_inner_top_sec__inner__column .footer__inner__top__inner__menu_list__footer__inner').hide();
        $('.footer_inner_top_sec__inner__column:first-child .footer_inner_top_sec__inner__column__heading').addClass('active');
        $('.footer_inner_top_sec__inner__column:first-child .footer_inner_top_sec__inner__column__content').slideDown(400);
    }

    $(".footer_inner_top_sec__inner__column__heading").on("click", function () {
        if (jQuery(window).width() < 992) {
            if (jQuery(this).next().is(":hidden")) {
                $(".footer_inner_top_sec__inner__column__heading").removeClass("active");
                $(".footer_inner_top_sec__inner__column__content").slideUp();
                jQuery(this).addClass("active");
                jQuery(this).next().slideDown();
            } else {
                jQuery(this).removeClass("active");
                jQuery(this).next().slideUp();
            }
        }
    });

    jQuery(".video_sec .video_poster_sec .play_btn").click(function () {
        setTimeout(function () {
            $('.lity').addClass('video_sec_popup_open');
            $('body').addClass('video_sec_popup_active');
        });
    });

    jQuery(document).on('lity:close', function (event, instance) {
        $('.lity').removeClass('video_sec_popup_open');
        $('body').removeClass('video_sec_popup_active');
    });

    $(".image_video_slider_sec").each(function (index) {
        let slide = $(this).find('.image_video_slider__item');
        let slider = $(this).find('.image_video_slider');
        let dots = $(this).find('.slider_dots');
        if ($(slide).length > 1) {
            $(slider).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                arrows: false,
                dots: true,
                fade: true,
                appendDots: $(dots),
            });
        }
    });

    jQuery(".image_video_slider_sec__inner .image_video_slider__item__inner .next_slide_data").on("click", function () {
        var nextIndex = jQuery(this).attr("data-next");
        if (nextIndex != undefined && nextIndex != null && nextIndex != "") {
            jQuery(".image_video_slider").slick("slickGoTo", (nextIndex + 1));
        }
    })

    var locHash = window.location.hash;
    if (locHash != undefined && locHash != "" && locHash != null) {
        if (jQuery(locHash + "_secscroll").length > 0) {
            setTimeout(() => {
                jQuery("body, html").animate({
                    scrollTop: jQuery(locHash + "_secscroll").offset().top - 150
                }, 1000);
                jQuery(".menu-item a[href='" + window.location.href + "']").addClass("link_active");
            }, 1000);
        }
    }
    jQuery("a:not([data-lity])").on("click", function (e) {
        e.preventDefault();
        // var secId = jQuery(this).attr("data-secid");
        // if (secId != undefined && secId != null) {
        //     localStorage.setItem("animateId", secId + "_secscroll");
        // }
        var link1 = jQuery(this).attr("href");
        var target1 = jQuery(this).attr("target");
        if (target1 == undefined || target1 == null || target1 == "") {
            target1 = "_self";
        }
        jQuery("a:not([data-lity])").removeClass("link_active");
        jQuery(this).addClass("link_active");
        if (link1.indexOf("#") > -1) {
            var link1Arr = link1.split('#');
            if (link1Arr.length > 1) {
                var linkId = link1Arr[1];
                if (jQuery("#" + linkId + "_secscroll").length > 0) {
                    jQuery("body, html").animate({
                        scrollTop: jQuery("#" + linkId + "_secscroll").offset().top - 150
                    }, 1000);
                } else {
                    window.open(link1, target1);
                }
            } else {
                window.open(link1, target1);
            }
        } else {
            window.open(link1, target1);
        }
    })

    jQuery(".map_section .map_section_inner .map_category_box .chevron_accordion").on("click", function () {
        jQuery(this).parent().toggleClass("smallHeight");
    })

    onScrollMobileStickyHeader();

    if (jQuery(".sticky_button_mobile_only").length > 0) {
        if (jQuery(".sticky_button_mobile_only").offset().top > (jQuery("footer.site-footer").offset().top - 100)) {
            jQuery(".sticky_button_mobile_only").addClass("hide_button");
        } else {
            jQuery(".sticky_button_mobile_only").removeClass("hide_button");
        }
    }

    // jQuery(".menu-item > a").each(function () {
    //     var link1 = jQuery(this).attr("href");
    //     if (link1.indexOf("#") > -1) {
    //         var link1Arr = link1.split('#');
    //         if (link1Arr.length > 1) {
    //             jQuery(this).attr("href", link1Arr[0]);
    //             jQuery(this).attr("data-secid", link1Arr[1]);
    //         }
    //     }
    // })

    // var animateInterval = setInterval(function () {
    //     if (document.readyState == "complete") {
    //         clearInterval(animateInterval);
    //         if (jQuery(".hero_banner .content_inner .dinosaur_video").length > 0) {
    //             jQuery(".hero_banner .content_inner .dinosaur_video").addClass("show_the_video");
    //         }
    //     }
    // }, 100);

    setTimeout(() => {
        if (jQuery(".hero_banner .content_inner .dinosaur_video").length > 0) {
            jQuery(".hero_banner .content_inner .dinosaur_video").addClass("show_the_video");
        } 
    }, 1000);
    
    // var animateInterval = setInterval(function () {
    //     if (document.readyState == "complete") {
    //         clearInterval(animateInterval);
    //         var secId = localStorage.getItem("animateId");
    //         if (secId != undefined && secId != "" && secId != null && jQuery("#" + secId).length > 0) {
    //             jQuery("body, html").animate({
    //                 scrollTop: jQuery("#" + secId).offset().top - 180
    //             }, 1000);
    //             setTimeout(() => {
    //                 localStorage.setItem("animateId", "");
    //             }, 1000);
    //         }
    //     }
    // })
});

jQuery(window).on("resize", function () {
    if (jQuery(window).width() < 991) {
        if (jQuery('.footer_inner_top_sec__inner__column .footer__inner__top__inner__menu_list__footer__inner').length > 0) {
            jQuery('.footer_inner_top_sec__inner__column .footer__inner__top__inner__menu_list__footer__inner').hide();
        }
        if (jQuery('.footer_inner_top_sec__inner__column:first-child .footer_inner_top_sec__inner__column__heading').length > 0) {
            jQuery('.footer_inner_top_sec__inner__column:first-child .footer_inner_top_sec__inner__column__heading').addClass('active');
        }
        if (jQuery('.footer_inner_top_sec__inner__column:first-child .footer_inner_top_sec__inner__column__content').length > 0) {
            jQuery('.footer_inner_top_sec__inner__column:first-child .footer_inner_top_sec__inner__column__content').slideDown(400);
        }
    }
});

jQuery(window).on("scroll", function () {
    onScrollMobileStickyHeader();

    if (jQuery(".sticky_button_mobile_only").length > 0) {
        if (jQuery(".sticky_button_mobile_only").offset().top > (jQuery("footer.site-footer").offset().top - 100)) {
            jQuery(".sticky_button_mobile_only").addClass("hide_button");
        } else {
            jQuery(".sticky_button_mobile_only").removeClass("hide_button");
        }
    }
})

function onScrollMobileStickyHeader() {
    if (jQuery(window).scrollTop() > 200) {
        jQuery(".site_header").addClass("sticky_enabled");
    } else {
        jQuery(".site_header").removeClass("sticky_enabled");
    }
    // if (jQuery(window).width() < 768) {
    // } else {
    //     jQuery(".site_header").removeClass("sticky_enabled");
    // }
}